//src/services/config/aws-config.ts

// Helper to check if we're in a production environment
const isProduction = window.location.hostname !== 'localhost' && 
                    window.location.hostname !== '127.0.0.1';

// Check if environment variables are missing in production
const hasRequiredEnvVars = () => {
    const requiredVars = [
        import.meta.env.VITE_AWS_REGION,
        import.meta.env.VITE_COGNITO_USER_POOL_ID,
        import.meta.env.VITE_COGNITO_CLIENT_ID
    ];
    
    const hasMissingVars = requiredVars.some(v => !v);
    
    if (isProduction && hasMissingVars) {
        return false;
    }
    
    return true;
};

export const awsConfig = {
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    apiEndpoint: import.meta.env.VITE_API_ENDPOINT,
    uploadBucket: import.meta.env.VITE_UPLOADS_BUCKET_NAME || '',
    Credentials: {
        accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID || '',
        secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY || ''
    },
    // Add a way to check if config is valid
    isConfigValid: hasRequiredEnvVars()
};

// Prevent AWS SDK from initializing immediately by using lazy loading
export const getAwsSdk = async () => {
    // Only import AWS SDK if config is valid
    if (!awsConfig.isConfigValid) {
        throw new Error('AWS configuration is invalid');
    }
    
    try {
        // Dynamically import AWS SDK components when needed
        const { CognitoIdentityProviderClient } = await import('@aws-sdk/client-cognito-identity-provider');
        return { CognitoIdentityProviderClient };
    } catch (error) {
        throw error;
    }
};
